import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'; 
import {CommonModule} from '@angular/common'

import { MapModule, MapAPILoader, 
   BingMapAPILoaderConfig, BingMapAPILoader,
   WindowRef, DocumentRef} from "angular-maps";
   
import { MapRootComponent} from './components/map-root/map-root.component'
import { InnerMapRootComponent } from './components/inner-map-root/inner-map-root.component';
import { MapFiltrationBoxComponent } from './components/map-filtration-box/map-filtration-box.component';
import { DynastyTimelineComponent } from './components/dynasty-timeline/dynasty-timeline.component';
import { InfoBoxPopupComponent } from './components/info-box-popup/info-box-popup.component';

import { AppService } from './services/app.service';


import {
  SwiperModule,
  SwiperConfigInterface,
  SWIPER_CONFIG
} from "ngx-swiper-wrapper";
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeFr from '@angular/common/locales/fr';
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeFr, 'fr');

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {};
declare var mapsApiKey :any;

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    CommonModule,   
    SwiperModule,
    MapModule.forRoot()
  ],
  declarations: [
    MapRootComponent,
    MapFiltrationBoxComponent,
    DynastyTimelineComponent,
    InfoBoxPopupComponent,
    InnerMapRootComponent
  ],
  providers: [
    AppService,
    {
      provide: MapAPILoader,
      deps: [], 
      useFactory: MapServiceProviderFactory
    },
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  exports:[
    InfoBoxPopupComponent,
    InnerMapRootComponent
  ]
  ,bootstrap:[
    MapRootComponent
  ]
})
export class MapsModule { }

export function MapServiceProviderFactory(){
  let bc: BingMapAPILoaderConfig = new BingMapAPILoaderConfig();
   bc.apiKey = mapsApiKey;
   bc.branch = "experimental"; 
  return new BingMapAPILoader(bc, new WindowRef(), new DocumentRef());
}

